export function generateRandomBase64(length: number) {
	const bytes = new Uint8Array(length);

	if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
		crypto.getRandomValues(bytes);
	} else {
		for (let i = 0; i < bytes.length; i += 1) {
			bytes[i] = Math.floor(Math.random() * 256);
		}
	}

	if (typeof window !== 'undefined') {
		let binary = '';
		for (let i = 0; i < bytes.length; i += 1) {
			binary += String.fromCharCode(bytes[i]);
		}
		return window.btoa(binary);
	}

	return Buffer.from(bytes).toString('base64');
}

export function generateRandomSafeBase64(length: number) {
	return generateRandomBase64(length).replace(/\+/g, '-').replace(/\//g, '_').replace(/[=]+$/, '');
}
